import React, { ReactElement } from 'react'
import SmartAIBasedFilteringIcon from 'images/organization/industries/schools/features/smart-ai.svg'
import CustomizablePoliciesByGradeLevelIcon from 'images/organization/industries/schools/features/customizable.svg'
import AppWebsiteControlIcon from 'images/organization/industries/schools/features/app-and-website.svg'
import SafeSearchEnforcementIcon from 'images/organization/industries/schools/features/safe-search.svg'
import DetailedReportingAlertsIcon from 'images/organization/industries/schools/features/detailed-reporting.svg'
import BYODRemoteLearningSupportIcon from 'images/organization/industries/schools/features/byod.svg'
import FeaturesContainer, {
  FeatureItem,
} from 'components/Organization/Industries/Common/FeaturesContainer'

export default function Features(): ReactElement {
  return (
    <FeaturesContainer
      sx={{
        '& > div': {
          width: ['100%', '33rem'],
          height: ['17rem', '20rem'],
        },
      }}
    >
      <FeatureItem
        svg={SmartAIBasedFilteringIcon}
        title="Smart AI-Based Filtering"
        description="Blocks inappropriate content in real-time."
      />
      <FeatureItem
        svg={CustomizablePoliciesByGradeLevelIcon}
        title="Customizable Policies by Grade Level"
        description="Different rules for elementary, middle, and high school students."
      />
      <FeatureItem
        svg={AppWebsiteControlIcon}
        title="App & Website Control"
        description="Block or allow access to YouTube, TikTok, Discord, and other platforms."
      />
      <FeatureItem
        svg={SafeSearchEnforcementIcon}
        title="Safe Search Enforcement"
        description="Force Google, Bing, and YouTube into Safe Mode automatically."
      />
      <FeatureItem
        svg={DetailedReportingAlertsIcon}
        title="Detailed Reporting & Alerts"
        description="View student activity, receive real-time alerts, and generate compliance reports."
      />
      <FeatureItem
        svg={BYODRemoteLearningSupportIcon}
        title="BYOD & Remote Learning Support"
        description="Extend filtering to student-owned laptops, tablets, and home learning environments."
      />
    </FeaturesContainer>
  )
}
